type Category = {
  value: string;
  id: string;
}[];

export const categories: Category = [
  { value: 'A', id: 'A' },
  { value: 'B', id: 'B' },
  { value: 'C', id: 'C' },
  { value: 'D', id: 'D' },
  { value: 'E', id: 'E' },
  { value: 'AB', id: 'AB' },
  { value: 'AC', id: 'AC' },
  { value: 'AD', id: 'AD' },
  { value: 'AE', id: 'AE' },
];
